import React from "react";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import SideNav from '../../shared/Sidenav';
import viewAccess from '../../../assets/images/viewOnlyAccess.svg';
import '../../../css/systemConfig/SystemConfig.css';
import TitleDescription from '../../../data/TitleDescription.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
toast.configure();

let viewOnly = false;
class SystemConfig extends React.Component {
    componentDidMount() {
        var selectedTiles = [];
        let roleData = this.props.data;
        const roleDataLength = roleData.length;
        for (let z = 0; z < roleDataLength; z++) {
            var rd = roleData[z].permissions;
            selectedTiles.push(rd)
        }
        selectedTiles.map(x =>
            x.map(md => {
                if (md.functionId == 1) {
                    if (md.method.includes("View & Edit")) {
                        viewOnly = true
                    }
                }
            }))
    }
    render() {
        const tile = [
            {
                "imgSrc": require('../../../assets/images/maintainFacility.svg'),
                "title": "Maintain Facility",
                "destPage": "/MaintainFacility"
            },
            {
                "imgSrc": require('../../../assets/images/maintainFunction.svg'),
                "title": "Maintain Function",
                "destPage": "/MaintainFunction"
            },
            {
                "imgSrc": require('../../../assets/images/maintainLookup.svg'),
                "title": "Maintain lookup",
                "destPage": "/MaintainLookup"
            }
        ]
        return (
            <div className="outer1"><div className="outer1" id="outerdiv">
                <MetaDecorator title={TitleDescription.systemConfigPageTitle} description={TitleDescription.systemConfigPageDescription} />
                <div className="systemConfigContainer">
                    <SideNav />
                    <div id="systemConfigPart" >
                        <h1 id='systemConfigtitle'>System Config</h1>
                        <div className="viewOnlyDiv" style={{ display: !viewOnly ? null : "none" }}>
                            <img alt="View Only Access" src={viewAccess} />
                            <span className="viewOnly">View Only Access</span>
                        </div>
                        <div >
                            <div className="cardContainer">
                                <div id="outerCard">
                                    {
                                        tile.map((x, index) => {
                                            return <Link to={x.destPage}
                                                id="systemConfigTileCard">
                                                <div class="mt-4" id="tile" >
                                                    <div className="tileLink">
                                                        <img src={x.imgSrc} class="d-inline-block align-top iconsize" alt="" loading="lazy" />
                                                        <p class="p-1 cardtextname">{x.title}</p>
                                                    </div>
                                                </div>
                                            </Link>
                                        }
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div></div>
        )
    }
}
function mapStateToProps(state) {
    return { data: state.adminRoleReducer.roleData }
}
export default connect(mapStateToProps)(SystemConfig);